import React, { useContext } from "react";
import { Link } from "gatsby";
import getImagePath from "helpers/get-image-path";
import ProductContext from "services/product-context";
import {
  box, imgBox, imgBoxSelected, selectedVariant, variantTitle
} from "./style.mod.scss";

const VariantList = (props) => {
  const { handle } = useContext(ProductContext);
  const { variants, onClick, isSelected, className } = props;
  // const isServierer = (variant) => {
  //   return handle == "olav-pfanne-kupfer-beschichtet" && variant.handle && variant.handle.includes("servierpfanne");
  // };

  return variants?.length > 1 && <ul className={`${box} ${className}`}>
    {variants?.map((variant) => <li className={`${imgBox} ${isSelected(variant) && imgBoxSelected}`} key={variant.id}>
      <Link
        to={`/products/${handle}/${variant.handle}`}
        role={onClick ? "button" : "image"}
        state={{ preserveScroll: true }}>
        {variant?.showTitle ? <p className={variantTitle}>{variant.title}</p> :
          <img className={selectedVariant} src={getImagePath(variant.image) || variant.image} alt={variant.image.alt} />
        }
      </Link>
      
      {/* {isServierer(variant) && (
        <span className={saleMessage}>
          <div className={saleMessageParent}>
            %
            <span className={triangle}></span>
          </div>
        </span>
      )} */}
    </li>)}
  </ul>;
};

export default VariantList;
